import React, { useState } from 'react'
import styled from 'styled-components/macro'
import { useTranslation } from 'react-i18next'
import { EyeOpen, EyeClose } from '@resultadosdigitais/tangram-react-icons'

import Input from '../Input'

const Container = styled.div`
  position: relative;
`

const AddornmentRight = styled.div`
  position: absolute;
  top: 50%;
  right: 5px;
  margin-top: -12px;
  cursor: pointer;
`

function PasswordInput(props) {
  const { t } = useTranslation()
  const [showPassword, setShowPassword] = useState(false)

  function handleToggleShowPassword(event) {
    event.preventDefault()
    setShowPassword(currentShowPassword => !currentShowPassword)
  }

  return (
    <Container>
      <Input type={showPassword ? 'text' : 'password'} {...props} />
      <AddornmentRight onClick={handleToggleShowPassword}>
        {showPassword && <EyeOpen title={t('PasswordInput.Conceal')} titleId="eye-open" />}
        {!showPassword && <EyeClose title={t('PasswordInput.Reveal')} titleId="eye-close" />}
      </AddornmentRight>
    </Container>
  )
}

export default PasswordInput
